/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // Funcionalidad personalizada para el selector de idioma
  document.addEventListener('DOMContentLoaded', function() {
    // Actualizar el texto del botón cuando se selecciona un idioma
    const languageButtons = document.querySelectorAll('.language-selector-btn');
    const languageOptions = document.querySelectorAll('[data-popout-option]');
    
    languageOptions.forEach(option => {
      option.addEventListener('click', function(e) {
        e.preventDefault();
        const languageCode = this.getAttribute('data-value');
        const languageName = this.querySelector('.language-name')?.textContent || '';
        
        // Actualizar todos los botones de idioma en la página
        languageButtons.forEach(button => {
          const codeSpan = button.querySelector('.language-code');
          if (codeSpan) {
            codeSpan.textContent = languageCode.toUpperCase();
          }
        });
        
        // Enviar el formulario de localización
        const form = this.closest('form');
        if (form) {
          const hiddenInput = form.querySelector('input[name="language_code"]');
          if (hiddenInput) {
            hiddenInput.value = languageCode;
            form.submit();
          }
        }
      });
    });
  });


  // ========================================
  // Custom Color Swatch - Product Card Update
  // ========================================
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || window.theme.moneyFormat || '€{{amount}}';

    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      const centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    const match = formatString.match(placeholderRegex);
    if (!match) return cents;

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function updateProductCard(cardElement, productData, variantId) {
    // Atualizar título do produto
    const titleElement = cardElement.querySelector('.product__grid__title');
    if (titleElement && productData.title) {
      titleElement.textContent = productData.title;
    }

    // Atualizar link do produto
    const productLinks = cardElement.querySelectorAll('[data-grid-link]');
    productLinks.forEach(link => {
      if (productData.url) {
        link.setAttribute('href', productData.url);
      }
    });

    // Atualizar preço
    const priceElement = cardElement.querySelector('.product__grid__price .price');
    if (priceElement && productData.variants && productData.variants.length > 0) {
      const variant = productData.variants.find(v => v.id === variantId) || productData.variants[0];
      
      if (variant) {
        // Formatar preço usando o formato do tema
        const priceFormatted = formatMoney(variant.price);
        priceElement.textContent = priceFormatted;

        // Atualizar compare at price se houver
        const compareAtElement = cardElement.querySelector('.compare-at');
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const comparePriceFormatted = formatMoney(variant.compare_at_price);
          
          if (compareAtElement) {
            compareAtElement.textContent = comparePriceFormatted;
            compareAtElement.style.display = '';
          }
          
          // Adicionar classe on-sale
          priceElement.classList.add('on-sale');
        } else {
          if (compareAtElement) {
            compareAtElement.style.display = 'none';
          }
          priceElement.classList.remove('on-sale');
        }
      }
    }

    // Atualizar imagens do produto
    if (productData.images && productData.images.length > 0) {
      // A API do Shopify retorna imagens como array de objetos {src: 'url'}
      const imageUrls = productData.images.map(img => {
        return typeof img === 'string' ? img : (img.src || img);
      });

      // Atualizar imagens principais
      const imageContainers = cardElement.querySelectorAll('.product-grid-item__image img, [data-grid-image] img');
      imageContainers.forEach((img, index) => {
        if (imageUrls[index]) {
          const imageUrl = imageUrls[index];
          img.src = imageUrl;
          img.srcset = `${imageUrl} 1x, ${imageUrl} 2x`;
          img.loading = 'lazy';
          
          // Atualizar alt text
          if (productData.title) {
            img.alt = productData.title;
          }
        }
      });

      // Atualizar background images se houver
      const bgImages = cardElement.querySelectorAll('[style*="background-image"]');
      bgImages.forEach((element, index) => {
        if (imageUrls[index]) {
          element.style.backgroundImage = `url(${imageUrls[index]})`;
        }
      });
    }

    // Atualizar disponibilidade
    const soldOutElement = cardElement.querySelector('.product__grid__price__sold');
    const variant = productData.variants.find(v => v.id === variantId) || productData.variants[0];
    
    if (variant && !variant.available) {
      if (soldOutElement) {
        soldOutElement.style.display = '';
      }
    } else {
      if (soldOutElement) {
        soldOutElement.style.display = 'none';
      }
    }

    // Atualizar data-item-id
    if (productData.id) {
      cardElement.setAttribute('data-item-id', productData.id);
    }

    // Atualizar aria-label
    if (productData.title) {
      cardElement.setAttribute('aria-label', productData.title);
    }

    // Atualizar elementos do quickview/inline add
    const productVariantElements = cardElement.querySelectorAll('product-grid-item-variant');
    const visibleVariantElement = cardElement.querySelector('product-grid-item-variant:not([hidden])');
    
    if (visibleVariantElement) {
      // Atualizar o elemento visível
      visibleVariantElement.setAttribute('data-grid-item', productData.id);
      visibleVariantElement.setAttribute('data-grid-item-variant', variantId);
      
      // Atualizar quickview se existir
      const quickviewHolder = visibleVariantElement.querySelector('[data-quickview-holder]');
      if (quickviewHolder && productData.handle) {
        quickviewHolder.setAttribute('data-quickview-holder', productData.id);
        
        // Atualizar x-data do Alpine.js para o quickview
        const quickviewToolbar = quickviewHolder.closest('[x-data*="productQuickViewButton"]');
        if (quickviewToolbar && productData.handle) {
          // Destruir Alpine.js antigo
          if (window.Alpine && quickviewToolbar._x_dataStack) {
            window.Alpine.destroyTree(quickviewToolbar);
          }
          
          // Remover e adicionar novo x-data
          quickviewToolbar.removeAttribute('x-data');
          quickviewToolbar.setAttribute('x-data', `productQuickViewButton(${productData.id}, '${productData.handle}')`);
          
          // Atualizar ID do modal template
          const modalTemplate = visibleVariantElement.querySelector('[data-quickview-modal-template]');
          if (modalTemplate) {
            const templateContent = modalTemplate.innerHTML;
            const newTemplateContent = templateContent.replace(/id="[^"]*"/g, `id="${productData.id}"`);
            modalTemplate.innerHTML = newTemplateContent;
          }
          
          // Re-inicializar Alpine.js
          if (window.Alpine) {
            window.Alpine.initTree(quickviewToolbar);
          }
        }
      }
    }
    
    // Atualizar todos os elementos para manter consistência
    productVariantElements.forEach(variantElement => {
      variantElement.setAttribute('data-grid-item', productData.id);
    });
  }

  function updateCardInfoFromVariant(cardElement, variantElement, productData) {
    // Atualizar título do produto
    const titleElement = cardElement.querySelector('.product__grid__title');
    if (titleElement && productData.title) {
      titleElement.textContent = productData.title;
    }

    // Atualizar link do produto
    const productLinks = cardElement.querySelectorAll('[data-grid-link]');
    productLinks.forEach(link => {
      if (productData.url) {
        link.setAttribute('href', productData.url);
      }
    });

    // Atualizar preço do elemento variant visível
    const variantId = parseInt(variantElement.getAttribute('data-grid-item-variant'));
    const variant = productData.variants.find(v => v.id === variantId) || productData.variants[0];
    
    if (variant) {
      const priceElement = cardElement.querySelector('.product__grid__price .price');
      if (priceElement) {
        const priceFormatted = formatMoney(variant.price);
        priceElement.textContent = priceFormatted;

        const compareAtElement = cardElement.querySelector('.compare-at');
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const comparePriceFormatted = formatMoney(variant.compare_at_price);
          if (compareAtElement) {
            compareAtElement.textContent = comparePriceFormatted;
            compareAtElement.style.display = '';
          }
          priceElement.classList.add('on-sale');
        } else {
          if (compareAtElement) {
            compareAtElement.style.display = 'none';
          }
          priceElement.classList.remove('on-sale');
        }
      }
    }

    // Atualizar data-item-id
    if (productData.id) {
      cardElement.setAttribute('data-item-id', productData.id);
    }

    // Atualizar aria-label
    if (productData.title) {
      cardElement.setAttribute('aria-label', productData.title);
    }
  }

  function reloadQuickAddElements(cardElement, productData, variantId) {
    // Esta função será chamada para recarregar elementos que dependem de HTML renderizado no servidor
    // Por enquanto, apenas atualizamos os atributos necessários
    const productVariantElements = cardElement.querySelectorAll('product-grid-item-variant');
    productVariantElements.forEach(variantElement => {
      // Atualizar quickview
      const quickviewHolder = variantElement.querySelector('[data-quickview-holder]');
      if (quickviewHolder && productData.handle) {
        const quickviewToolbar = quickviewHolder.closest('[x-data*="productQuickViewButton"]');
        if (quickviewToolbar && productData.handle) {
          quickviewToolbar.removeAttribute('x-data');
          quickviewToolbar.setAttribute('x-data', `productQuickViewButton(${productData.id}, '${productData.handle}')`);
          
          if (window.Alpine) {
            window.Alpine.initTree(quickviewToolbar);
          }
        }
      }
    });
  }

  // Event listener para cliques nos botões de cor customizados
  document.addEventListener('click', function(e) {
    const customSwatchButton = e.target.closest('[data-custom-swatch-link]');
    
    if (customSwatchButton) {
      e.preventDefault();
      
      const productHandle = customSwatchButton.getAttribute('data-product-handle');
      const cardElement = customSwatchButton.closest('product-grid-item');
      
      if (!productHandle || !cardElement) {
        return;
      }

      // Salvar o aria-current do botão clicado para restaurar depois
      const clickedButton = customSwatchButton;

      // Mostrar loading state
      cardElement.style.opacity = '0.7';
      cardElement.style.pointerEvents = 'none';

      // Fazer fetch do HTML do card usando a seção api-product-grid-item
      const rootUrl = window.theme?.routes?.root_url || '/';
      const url = `${rootUrl}products/${productHandle}?section_id=api-product-grid-item`;
      
      fetch(url)
        .then(response => {
          if (!response.ok) {
            throw new Error('Product not found');
          }
          return response.text();
        })
        .then(html => {
          // Criar um elemento temporário para parsear o HTML
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          
          // Extrair o conteúdo do card (dentro de [data-api-content])
          const apiContent = tempDiv.querySelector('[data-api-content]');
          if (!apiContent) {
            throw new Error('Card content not found');
          }
          
          // Obter o novo card (product-grid-item)
          const newCard = apiContent.querySelector('product-grid-item');
          if (!newCard) {
            throw new Error('Product grid item not found');
          }
          
          // Preservar a posição do card no DOM
          const parentElement = cardElement.parentElement;
          const nextSibling = cardElement.nextSibling;
          
          // Substituir o card antigo pelo novo
          parentElement.replaceChild(newCard, cardElement);
          
          // Restaurar o aria-current no botão correto do novo card
          const newButtons = newCard.querySelectorAll('[data-custom-swatch-link]');
          newButtons.forEach(btn => {
            const btnHandle = btn.getAttribute('data-product-handle');
            if (btnHandle === productHandle) {
              btn.setAttribute('aria-current', 'true');
            } else {
              btn.removeAttribute('aria-current');
            }
          });
          
          // Re-inicializar Alpine.js no novo card
          if (window.Alpine) {
            window.Alpine.initTree(newCard);
          }
          
          // Disparar evento para que outros scripts saibam que o card foi atualizado
          document.dispatchEvent(new CustomEvent('theme:product-card:updated', {
            detail: { card: newCard, productHandle: productHandle }
          }));
          
          // Restaurar estado normal
          newCard.style.opacity = '';
          newCard.style.pointerEvents = '';
        })
        .catch(error => {
          console.error('Error fetching product card:', error);
          
          // Restaurar estado normal mesmo em caso de erro
          cardElement.style.opacity = '';
          cardElement.style.pointerEvents = '';
        });
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
